
import { DeviceRestrictionsContent } from "./DeviceRestrictionsContent";

interface Device {
  id: string;
  name: string;
  user: string;
  os: string;
  version: string;
  status: "active" | "prepared" | "inactive";
  lastSync: string;
  group: string;
}

interface DeviceRestrictionsTabProps {
  device: Device;
}

export const DeviceRestrictionsTab = ({ device }: DeviceRestrictionsTabProps) => {
  return (
    <div className="h-full w-full">
      <DeviceRestrictionsContent device={device} activeSection="device" />
    </div>
  );
};
